import {FC, useState, useEffect} from 'react'
import {Dropdown} from 'react-bootstrap'

type Props = {
  onSelectedDate: any
}

const RangeDateContent: FC<Props> = ({onSelectedDate}) => {
  const [formValue, setFormValue] = useState<any>({})
  const [readonlyEndDate, setReadonlyEndDate] = useState<boolean>(true)
  const [show, setShow] = useState(false)

  const onInput = (name: string, e: any) => {
    if (name == 'waktu_administrasi_start') {
      setFormValue({
        ...formValue,
        waktu_administrasi_start: e.target.value,
        waktu_administrasi_end: '',
      })
      return
    }

    setFormValue({
      ...formValue,
      [name]: e.target.value,
    })
  }

  const handleApply = () => {
    onSelectedDate('waktu_administrasi_start', formValue?.waktu_administrasi_start)
    onSelectedDate('waktu_administrasi_end', formValue?.waktu_administrasi_end)
    setShow(false)
  }

  const showInput = () => {
    if (formValue?.waktu_administrasi_start && !formValue?.waktu_administrasi_end) {
      return <p>{formValue?.waktu_administrasi_start}</p>
    }

    if (formValue?.waktu_administrasi_start && formValue?.waktu_administrasi_end) {
      return (
        <p>
          {formValue?.waktu_administrasi_start} s.d {formValue?.waktu_administrasi_end}
        </p>
      )
    }

    return <p>--Filter Waktu Pendaftaran--</p>
  }

  const handleToggle = (isOpen: boolean) => {
    setShow(isOpen)
  }

  return (
    <Dropdown show={show} onToggle={handleToggle} autoClose='outside'>
      <Dropdown.Toggle
        variant='light'
        className='w-100 text-start fw-bold bg-white p-3 d-flex justify-content-between align-items-center'
        style={{
          border: '1px solid #e4e6ef',
          backgroundImage: 'none', // hilangkan panah ▼
        }}
      >
        {showInput()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className='mb-2 p-3 row'>
          <div className='col-md-12'>
            <div className='mb-3'>
              <p className='mb-1'>Dari</p>
              <input
                type='date'
                onChange={(e) => {
                  onInput('waktu_administrasi_start', e)
                  setReadonlyEndDate(false)
                }}
                className='form-control'
                value={formValue?.waktu_administrasi_start}
              />
            </div>
          </div>
          <div className='col-md-12'>
            <div className=''>
              <p className='mb-1'>Sampai</p>
              <input
                type='date'
                readOnly={readonlyEndDate}
                min={formValue?.waktu_administrasi_start}
                onChange={(e) => {
                  onInput('waktu_administrasi_end', e)
                }}
                className='form-control'
                value={formValue?.waktu_administrasi_end}
              />
            </div>
          </div>
        </div>

        <div
          className='col-md-12 d-grid px-5 pt-5 pb-3 border border-bottom-0 border-left-0 rounded'
          style={{boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)'}}
        >
          <button
            className='btn btn-primary btn-sm w-100'
            style={{background: ' var(--Primary-L-500, #F95E2F)'}}
            onClick={() => handleApply()}
          >
            Terapkan
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

const RangeDate: FC<Props> = ({onSelectedDate}) => {
  return <RangeDateContent onSelectedDate={onSelectedDate} />
}

export default RangeDate
